import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/vs/[competitor]/CompetitorComparisonClient.tsx");
